import * as Factory from 'factory.ts'
import faker from 'faker'

import { type BillingHistoryItem } from '@webapp/models'

export const BillingHistoryItemMock =
  Factory.Sync.makeFactory<BillingHistoryItem>({
    id: Factory.each(() => faker.random.number()),
    billed_qty: Factory.each(() => faker.random.number(10)),
    received_qty: Factory.each(() => faker.random.number(10)),
  })
